export { default } from "./MailinglistList";



// WEBPACK FOOTER //
// ./src/components/MailinglistList/index.ts